import { BaseError } from '@nsftx/seven-client-retail-utils'

export type TicketPayoutValidationErrorType = 'ST_TICKET_PAYOUT_VALIDATION_WORKING_TIME_ERROR'

export default class TicketPayoutValidationError extends BaseError<TicketPayoutValidationErrorType> {
  constructor(
    public message: string,
    public code: TicketPayoutValidationErrorType
  ) {
    super(message, code)
    Object.setPrototypeOf(this, TicketPayoutValidationError.prototype)
    this.name = this.constructor.name
  }
}
